module.exports = __webpack_public_path__ + "static/media/0.28a38990.jpg";